import type { TreeNode } from 'tree-model';

import type { TreeReducerModel } from '../../ducks/tree/types';

export const getTreeNodePathKey = (node: TreeNode<TreeReducerModel>): string =>
  node
    .getPath()
    .map((pathNode) => pathNode.model.id)
    .join('/');
